let canvas;
let baublesDone = false;
// let voteResults = [
//   { product: "Blush Peach", votes: 0 },
//   { product: "Butter Cream", votes: 5 },
//   { product: "Caramel", votes: 0 },
//   { product: "Copper Light", votes: 0 },
//   { product: "Matte Champagne", votes: 0 },
//   { product: "Tangerine Zest", votes: 0 },
//   { product: "Toffee Brown", votes: 0 },
//   { product: "Choco Lit", votes: 1 },
//   { product: "Disco Green", votes: 2 },
//   { product: "Honey Gold", votes: 0 },
//   { product: "Pearl White", votes: 0 },
//   { product: "Stardust Gold", votes: 0 }
// ];
let voteResults = [];
//let isPopUpHidden = true; //uncomment for testing without having email pop up
// Define a color palette for products
const images = {};
const imagePaths = {
  
  "Blush Peach": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Blush-peach-B-ShinyGold-Frames-of-Butter.png?v=1734786852",
  "Butter Cream": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Buttter-Cream-C-StarryGold-Frames-of-Butter.png?v=1734787518",
  "Caramel": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Caramel-B-StarryGold-Frames-of-Butter.png?v=1734787442",
  "Copper Light": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Copper-Light-A-White-Frames-of-Butter.png?v=1734787246",
  "Matte Champagne": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Matte-Champagne-A-White-Frames-of-Butter.png?v=1734787404",
  "Tangerine Zest": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Tangerine-Zest-A-White-Frames-of-Butter.png?v=1734787490",
  "Toffee Brown": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Toffee-Brown-A-White-Frames-of-Butter.png?v=1734787193",
  "Choco Lit": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Choco-Lit-B-StarryGold-Frames-of-Butter.png?v=1734787144",
  "Disco Green": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Disco-Green-B-White-Frames-of-Butter.png?v=1734787031",
  "Honey Gold": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Honey-Gold-B-White-Frames-of-Butter.png?v=1734786956",
  "Pearl White": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Pearl-White-B-RoseGold-Frames-of-Butter.png?v=1734787285",
  "Stardust Gold": "https://cdn.shopify.com/s/files/1/0605/8524/6970/files/24-BB-SQ-Stardust-Gold-A-White-Frames-of-Butter.png?v=1734787077"
};

var Engine = Matter.Engine,
    //Render = Matter.Render,
    Runner = Matter.Runner,
    Bodies = Matter.Bodies,
    Composite = Matter.Composite;
var engine;
var world;
var baubles = [];
var runner;
var ground;
var wall1, wall2;

function preload() {
  // Load all images before setup
  console.log("loading images")
  for (const [product, path] of Object.entries(imagePaths)) {
    images[product] = loadImage(path);    
  }
  
}

function setup() {
  background('#936f3b');
  // Get the container element
  const container = document.getElementById('canvas-container');
  
  // Create the canvas to match the container's dimensions
  canvas = createCanvas(container.offsetWidth, container.offsetHeight);
  canvas.parent('canvas-container'); // Attach canvas to container
  console.log("inside canvas"); 
  engine = Engine.create();
  world = engine.world
  
  runner = Runner.create();
  Runner.run(runner, engine);
  var groundOption = {
    isStatic: true
  }
  ground = Bodies.rectangle(width/2 ,height-5, width, 10, groundOption);
  wall1 = Bodies.rectangle(2 ,height/2, 4, height, groundOption);
  wall2 = Bodies.rectangle(width-2 ,height / 2, 4, height, groundOption);
  Composite.add(world, [ground, wall1, wall2]);
 
  
  if (typeof dataFetched !== 'undefined') {
    console.log("test1");
    voteResults = dataFetched; // Update circleData with fetched data
    createBaubleFromVotes();
  } else {
    // If data isn't ready yet, wait for it
    let checkCount = 0; // To limit the number of checks
    const maxChecks = 1000; // Stop checking after 10 seconds (100 * 100ms)
    const checkInterval = setInterval(() => {
      if (typeof dataFetched !== 'undefined') {
        voteResults = dataFetched; 
        clearInterval(checkInterval); // Stop checking after data is ready
        createBaubleFromVotes();
        console.log(voteResults);
      }
      checkCount++;
      if (checkCount >= maxChecks) {
        clearInterval(checkInterval); // Stop checking after 10 seconds
        console.warn('Data not fetched within 10 seconds.');
      }
      }, 100);
  }
  
}
function displayStartMessage() {
  
  let message = ' ';
  let x = width / 2; // Center of canvas
  let y = height / 2; // Center of canvas
  let letterSpacing = 2; // Custom letter spacing in pixels
  
  textSize(30);
  textAlign(LEFT); // Position letters from left to right
  
  textFont('Avenir Next' ||'sans serif');
  
  // fill(255);
  
  // let currentX = x - textWidth(message) / 2; // Center the whole message
  // for (let i = 0; i < message.length; i++) {
  //   let char = message[i];
  //   text(char, currentX, y);
  //   currentX += textWidth(char) + letterSpacing; // Add character width + 2px spacing
  // }
 
} 

  function draw() {
   
    // background(112, 119, 111);//gray
   background('#936f3b'); //moustard
  
    
    
    if(isPopUpHidden){
      if(!baublesDone){
        createBaubleFromVotes();
        // console.log("bubllll");
        baublesDone = true;
      }     
     
      
      for (let bauble of baubles){
        bauble.show();  
      }
    } else {
      displayStartMessage();
      
    }
    
     
  }

// function createBaubleFromVotes() {
//   baubles = [];
//   for (let i = 0; i < voteResults.length; i++) {
//     const product = voteResults[i].product;
//     const votes = voteResults[i].votes;
//     const productImage = images[product];

//     for (let j = 0; j< votes; j++){
//       const x= random(width/2-50, width/2 +50);
//       const y = random(-200,0);
//       const r = random(15,20);

//       const bauble = new Bauble(x, y, r, productImage);
//       baubles.push(bauble);
//     }
//   }
// }
function createBaubleFromVotes() {
  baubles = [];
  const minRadius = 17;
  const maxRadius = 23;
  let currentY = 0; // Starting position for Y

  for (let i = 0; i < voteResults.length; i++) {
    const product = voteResults[i].product;
    const votes = voteResults[i].votes;
    const productImage = images[product];

    for (let j = 0; j < votes; j++) {
      const r = random(minRadius, maxRadius);
      const x = random(width / 2 - 50, width / 2 + 50); // Random X within bounds
      currentY -= r * 2; // Move Y up by twice the radius

      const bauble = new Bauble(x, currentY, r, productImage);
      baubles.push(bauble);
    }
  }
}


  function windowResized() {
   const container = document.getElementById('canvas-container');
  resizeCanvas(container.offsetWidth, container.offsetHeight);
  
  // Clear existing baubles
  baubles = [];
  
  // Reset Matter.js world
  Composite.clear(world); // Clear the world completely
  
  // Recreate the ground and walls
  var groundOption = { isStatic: true };
  ground = Bodies.rectangle(width / 2, height - 5, width, 10, groundOption);
  wall1 = Bodies.rectangle(5, height / 2, 10, height, groundOption);
  wall2 = Bodies.rectangle(width - 5, height / 2, 10, height, groundOption);
  Composite.add(world, [ground, wall1, wall2]);
  
  // Recreate baubles based on the votes
  createBaubleFromVotes();
  }
